import React from 'react';

import LabelField from '../../../components/plain/LabelField';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

class TabAANames extends React.Component {

	constructor(props) {
		super(props);
	}

	nameCardBuilder = (fieldName, index) => {
		let plain = this.props.plain;
		let card = '';
		let language = fieldName.value.language.value;
		if( language ) {
			let languageText = plain.realm.getEnumerationItemText( plain.enumLanguage, language);
			card += '[' + languageText + '] ';
		}
		if( fieldName.value.name.value )
			card += fieldName.value.name.value;
		return card;
	}
	buildNamePanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<NamePanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'name'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildNamePanel} itemCardBuilder={this.nameCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class NamePanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0', width: '300px', marginRight: '20px'}}}
						/>
						<FieldString instance={instance} path={'place'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'expandedName'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '4'}}}
						 />
					</div>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'comment'} parentField={parentField} />
						<FieldString  instance={instance} path={'comment'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default TabAANames;